<template>
  <InputAuto
    ref="sug"
    v-model="selected"
    :template="template"
    :scope="scope"
    :errorsBag="errorsBag"
    :label="label"
    :name="name"
    :isLoading="isLoading"
    :sugestoes="sugestoes"
    :disabled="habilitarCampo()"
    :camposMostrarInput="['nome', 'filial.nome']"
    :camposFiltrar="['nome', 'filial.nome']"
    :erroConexao="erroConexao"
    :rotaTelaCadastro="'rota-usuarios-cadastro'"
    separador=" - "
    msgSemRegistros='Não há barbeiros cadastrados...' />
</template>

<script>
import InputAuto from '@/components/inputs/autocomplete/InputAuto.vue'
import InputAutoMixin from '@/components/inputs/autocomplete/InputAutoMixin'

import TemplateBarbeiros from './templates/TemplateBarbeiros.vue'
import UsuariosService from '../../../services/usuarios.service'

export default {
  name: 'InputSugestaoBarbeiros',
  mixins: [InputAutoMixin],
  components: {
    InputAuto,
  },
  data() {
    return {
      template: TemplateBarbeiros,
    }
  },
  methods: {
    async carregaTudo() {
      try {
        this.erroConexao = false
        this.isLoading = true
        const retorno = await UsuariosService.retornaTodosSemLimite()
        this.sugestoes = retorno.lista
      } catch (error) {
        this.erroConexao = error.tipo === 'MSG_ERRO'
        this.sugestoes = []
      } finally {
        this.isLoading = false
      }
    },
  },
}

</script>
